import { ChangeDetectionStrategy, Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';

import { ColumnDefDirective } from '../../directives/column-def.directive';
import { TableComponent } from '../table/table.component';

@Component({
  selector: '[mcrai-sort-header]',
  template: `<ng-content></ng-content>
<div
  *ngIf="showArrow()"
  class="mcrai-sort-header__arrow"
  [class.mcrai-sort-header__arrow--desc]="isDesc()"
  [class.mcrai-sort-header__arrow--asc]="isAsc()"
></div>
`,
  styles: [`.mcrai-sort-header{cursor:pointer}.mcrai-sort-header__arrow{margin-left:15px}.mcrai-sort-header__arrow--desc{width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-top:7px solid #000}.mcrai-sort-header__arrow--asc{width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #000}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-sort-header]': 'true'
  }
})
export class SortHeaderComponent implements OnInit {
  private _id: string;

  constructor(
    private _mcraiTable: TableComponent<any>,
    private _mcraiColumnDef: ColumnDefDirective
  ) { }

  ngOnInit() {
    this._id = this._mcraiColumnDef.name;
  }

  @HostListener('click')
  _onClick(): void {
    this._mcraiTable.sort(this._id);
  }

  public isSorting(): boolean {
    return !!this._mcraiTable.activeSort;
  }

  public showArrow(): boolean {
    return this.isSorting() && this._mcraiTable.activeSort.column === this._id;
  }

  public isAsc(): boolean {
    return this.isSorting() && this._mcraiTable.activeSort.direction === 'asc';
  }

  public isDesc(): boolean {
    return this.isSorting() && this._mcraiTable.activeSort.direction === 'desc';
  }

}
